import type { ProductSlugs } from '@deque/billing-utils';
import { type SupportedIntegrationProductSlugs } from '../constants';

/**
 * This is a marker type used to allow object literals in JSX locations
 * that would normally be disallowed, but which are safe in the context of
 * a react-i18next `<Trans>` component (where they'll be replaced with
 * translated strings before React sees them).
 *
 * Usage:
 *
 * ```tsx
 * <Trans>Hello <strong>{{ name } as TransInterpolation}</strong>!</Trans>
 * ```
 *
 * See:
 * - ../../../../README.md#localization ("Trans component examples")
 * - https://react.i18next.com/latest/trans-component#typescript-usage
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TransInterpolation = any;

export type BaseModalProps = {
  show: boolean;
  onClose: () => void;
};

export enum InterWindowMessageType {
  REFRESH_INTEGRATION_CONNECTION = 'REFRESH_INTEGRATION_CONNECTION'
}

export type InterWindowMessageDataRefreshIntegrationConnection = {
  connection_id: string;
  product_slug:
    | SupportedIntegrationProductSlugs
    | ProductSlugs.axeAuditorIntegration;
};
export type InterWindowMessage = {
  message_type: InterWindowMessageType;
  data: InterWindowMessageDataRefreshIntegrationConnection; // OR other types for other types of messages
};
